<template>
  <section class="section">
    <div class="container">
      <h1 class="title">
        Зона 1
      </h1>
      <img src="@/assets/images/zona1.jpg" alt="" />

      <h1 class="title">
        Зона 2
      </h1>
      <img src="@/assets/images/zona2.jpg" alt="" />

      <h1 class="title">
        Зона 3
      </h1>
      <img src="@/assets/images/zona3.jpg" alt="" />
    </div>
    <Footer></Footer>
  </section>
</template>

<script>
import Footer from '@/components/Footer.vue'
export default {
  components: {
    Footer
  }
}
</script>

<style></style>
